import React from 'react';
import OverviewPage from 'pages/app/YearlyCalendar/Overview';
import SchedulePlanPage from 'pages/app/YearlyCalendar/SchedulePlans';
import SchedulePlanDetailPage from 'pages/app/YearlyCalendar/SchedulePlans/Detail';
import NotificationPage from 'pages/app/YearlyCalendar/Notifications';
import SchedulePlanEditPage from 'pages/app/YearlyCalendar/SchedulePlans/Edit';
import ReportsPage from 'pages/app/YearlyCalendar/Reports';

export const pathnames = {
  overview: '/app/yearly-calendar/overview',
  schedulePlan: '/app/yearly-calendar/schedule-plan',
  schedulePlanDetail: '/app/yearly-calendar/schedule-plan/detail/:id',
  editPlanDetail: '/app/yearly-calendar/schedule-plan/edit/:id',
  notifications: '/app/yearly-calendar/notifications',
  reports: '/app/yearly-calendar/reports'
};

const YearlyCalendarRoutes = [
  {
    path: pathnames.overview,
    element: <OverviewPage />
  },
  {
    path: pathnames.schedulePlan,
    element: <SchedulePlanPage />
  },
  {
    path: pathnames.schedulePlanDetail,
    element: <SchedulePlanDetailPage />
  },
  {
    path: pathnames.notifications,
    element: <NotificationPage />
  },
  {
    path: pathnames.editPlanDetail,
    element: <SchedulePlanEditPage />
  },
  {
    path: pathnames.reports,
    element: <ReportsPage />
  }
];

export default YearlyCalendarRoutes;
